import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './tsys-payment.html';

@Component({
  controllerAs: 'tsysPayment',
  template
})

export default class tsysPayment {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    'toaster',
    '$stateParams',
    'spinnerService',
    'orderService',
    'authService',
    '$window', 'APP',
    'GlobalPayments'
  ];


  constructor($scope, $ngRedux, $state, $toaster, $stateParams, $spinner, $order, $auth, $window, APP, GlobalPayments) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    console.log("Calling tsys-payment");
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$order = $order;
    this.$toaster = $toaster;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.$window = $window;
    this.$auth = $auth;
    this.APP = APP;
    this.$spinner = $spinner;
    this.giftCardNumbers = [];
    this.totalGiftAmount = 0.00;

    this.hasErplyPaymentInitialized=false;
    this.heartand_Approval = "APPROVAL";
    console.log("this.$stateParams.giftcardReq : ", this.$stateParams.giftcardReq);
    this.giftCardsRequest = this.$stateParams.giftcardReq;
    $spinner.show('appSpinner');
    $order.getOrderAmount(this.$stateParams.orderId)
      .then(success => {
        this.orderAmount = success.data;
        $order.getPaymentKeys().then(success => {
          console.log("success -- ", success);
          this.paymentGlobalKey = success.data.globalKey;
          this.env = success.data.enviroment;
          // ----
          this.initializeTsys(GlobalPayments);
        })
          .finally(() => $spinner.hide('appSpinner'));
      });

    this.$onDestroy = function () {
      this.hps.dispose();
    };
  }

  initializeTsys(GlobalPayments) {
    var $ctrl = this;
    GlobalPayments.configure( {
        'X-GP-Api-Key' : this.paymentGlobalKey,
        'X-GP-Environment' : this.env,
        'enableAutocomplete' : true
      });
    var default_tsys = this.default_Tsys();

    // console.log("Default_tsys : ", default_tsys.styles.button);
    if(!this.isMobileOnly()){
      default_tsys.styles.button.width = "auto !important";
    }

    var cardForm = GlobalPayments.ui.form(default_tsys);
    
    cardForm.on("token-success", resp => {
      // add a payment token to form as a hidden input
      console.log("token-success", resp);
      const token = document.createElement("input");
      token.type = "hidden";
      token.name = "temporary_token";
      token.value = "resp.temporary_token";

      // submit temporary_token to backend, process with our gateway
      // const form = document.getElementById("payment-form");
      // form.appendChild(child);
      // form.submit;

      console.log("Token Success", resp.temporary_token);
        $ctrl.$spinner.show('appSpinner');
        let dataReq = {
          "token": resp.temporary_token,
          "orderId": $ctrl.$stateParams.orderId,
          // "isNewCard": true,
          "cardLast4": resp.card.masked_card_number,
          "cardType": resp.card.type,
          "cardNumber": resp.card.masked_card_number,
          "expiryMonth": resp.card.expiry_month,
          "expiryYear": resp.card.expiry_year,
          "getGiftCardPreAuthRequest": {
            "getGiftCardPreAuthCardRequestList": $ctrl.giftCardsRequest
          }
        };

        if(!$ctrl.hasErplyPaymentInitialized){
          $ctrl.hasErplyPaymentInitialized=true;
              $ctrl.$order.initializePaymentTsys(dataReq)
                .then(success => {
                  $ctrl.hasErplyPaymentInitialized=false;
                  $ctrl.$spinner.hide('appSpinner');
                  $ctrl.showHeartLandPage = false;
                  if (success.data.successCode === '00' && success.data.message === $ctrl.heartand_Approval) {
                    $ctrl.$state.go('payment.success', {
                      orderId: $ctrl.$stateParams.orderId,
                      logString: JSON.stringify(success),
                      isCardSaved: true
                    });
                  }
                  else {
                    $ctrl.$state.go('payment.failure', {
                      orderId: $ctrl.$stateParams.orderId,
                      reasonCode: success.data.successCode,
                      logString: JSON.stringify(success)
                    });
                  }
                },
                  error => {
                    $ctrl.hasErplyPaymentInitialized=false;
                    $ctrl.showHeartLandPage = false;
                    $ctrl.$spinner.hide('appSpinner');
                    $ctrl.$state.go('payment.failure', {
                      orderId: $ctrl.$stateParams.orderId,
                      logString: JSON.stringify(error)
                    });
                  }
                )
                .catch(err => {
                  $ctrl.hasErplyPaymentInitialized=false;
                  $ctrl.showHeartLandPage = false;
                  console.log("Api call failure -  ", err);
                  $ctrl.$spinner.hide('appSpinner');
                  $ctrl.$state.go('payment.failure', {
                    orderId: $ctrl.$stateParams.orderId,
                    logString: JSON.stringify(err)
                  });
                });
        }
    });

    cardForm.on("token-error", resp => { 
      // show error to the consumer 
      console.log("token-error", resp);
      console.log("token-error", resp);
      $ctrl.hasErplyPaymentInitialized=false;
      $ctrl.showHeartLandPage = false;
      $ctrl.$spinner.hide('appSpinner');
      $ctrl.$state.go('payment.failure', {
        orderId: $ctrl.$stateParams.orderId,
        logString: JSON.stringify(resp)
      });
    });

    GlobalPayments.on("error", error => { 
      console.log("Global error", error);
      $ctrl.hasErplyPaymentInitialized=false;
      $ctrl.showHeartLandPage = false;
      console.log("Api call failure -  ", error);
      $ctrl.$spinner.hide('appSpinner');
      $ctrl.$state.go('payment.failure', {
        orderId: $ctrl.$stateParams.orderId,
        logString: JSON.stringify(error)
      });
    });

    cardForm.on("card-number-test", function (resp) {
      console.log("card-number-test", resp);
      $ctrl.cardvalid = resp.valid;
      $ctrl.submitButtonState(cardForm);
      // console.log("card-number-test", resp);
    });

    cardForm.on("card-expiration-test", resp => {
      // resp.valid will be “true” or “false”
      console.log("card-expiration-test", resp);
      $ctrl.expdatevalid = resp.valid;
      $ctrl.submitButtonState(cardForm);
      // console.log("card-expiration-test", resp);
    });

    cardForm.on("card-cvv-test", resp => {
      console.log("card-cvv-tes", resp);
      $ctrl.cvvalid = resp.valid;
      $ctrl.submitButtonState(cardForm);
      // console.log("card-cvv-test", resp);
    });

    // this.$onDestroy = function () {
    //   this.cardForm.dispose();
    // };
  }

  clearIframeFields() {
    var heartlandcontenthtml = angular.element(document.querySelector('#heartlandcontent'));
    var iframesG = angular.element(document.querySelector('#iframes'));
    var cardNumberIframe = angular.element(document.querySelector('#iframesCardNumber'));
    var CardExpIframe = angular.element(document.querySelector('#iframesCardExpiration'));
    var CardCvvIframe = angular.element(document.querySelector('#iframesCardCvv'));
    var CardSubmitIframe = angular.element(document.querySelector('#iframesSubmit'));
  }

  goBack() {
    this.$state.go('delivery');
  }

  round(value){
    return value.toFixed(2);
  }

  getTotalGiftCardAddedAmount() {
    var total = 0.00;
    angular.forEach(this.giftCardsRequest, function (item, key) {
      if (item) {
        total = total + item.amount;
      }
    });
    return total;
  }

  submitButtonState(cardForm) {
    var $ctrl = this;
    // console.log("cardForm := ",cardForm);
    // console.log($ctrl.cardvalid + ", " + $ctrl.expdatevalid + ", " + $ctrl.cvvalid);
    if(($ctrl.cvvalid && $ctrl.cardvalid && $ctrl.expdatevalid)){
      cardForm.addStylesheet({
        "button": {
          "pointer-events": "auto",
          "opacity": "1",
  
          'box-sizing': 'border-box',
          'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
          'font-size': '15px',
          'line-height': '1',
          // 'width': 'auto !important',
          'outline': '0',
          'padding': '.5278em',
          'vertical-align': 'baseline',
          'height': '50px',
          'background-color': '#a4182d',
          'font-family': 'sans-serif',
          'text-transform': 'uppercase',
          'border': '0 solid transparent',
          'color': '#fff',
          'cursor': 'pointer',
          'flex': '0.61 1 auto !important'
        }
      });
    } else {
      cardForm.addStylesheet({
      "button": {
        "pointer-events": "none",
        "opacity": ".5",


        'box-sizing': 'border-box',
        'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
        'font-size': '15px',
        'line-height': '1',
        // 'width': 'auto !important',
        'outline': '0',
        'padding': '.5278em',
        'vertical-align': 'baseline',
        'height': '50px',
        'background-color': '#a4182d',
        'font-family': 'sans-serif',
        'text-transform': 'uppercase',
        'border': '0 solid transparent',
        'color': '#fff',
        // 'cursor': 'pointer',
        'flex': '0.61 1 auto !important'
      }
    });
    }
  }

  isMobileOnly() {
    // return ( this.$window.innerWidth < 752 && this.$window.innerHeight < 752 );
    return (this.$window.innerWidth < 784);
  }

  isIpad() {
    return ( this.$window.innerWidth < 1248 && this.$window.innerWidth > 767 );
  }

  default_Tsys(){
    var $ctrl=this;
    return {
          type: 'iframe',
          fields : {
            'card-number': {
              target: '#card-number',
              placeholder: 'xxxx xxxx xxxx xxxx'
            },
            'card-expiration': {
              target: '#card-expiration',
              placeholder: 'MM / YYYY'
            },
            'card-cvv': {
              target: '#card-cvv',
              placeholder: 'xxx'
            },
            'submit': {
              text: 'Pay $'+ this.round($ctrl.orderAmount-this.getTotalGiftCardAddedAmount()),
              target: '#submit'
            }
          },

          styles: {
            
        "input": {
          "outline": "none",
          "border-width": "0",
          "letter-spacing": "2px",
          "width": "20px",
          "height" : "40px"
        },
        "input, select": {
          "padding": "5px 10px",
          "font-size": "13px",
          "background": "#f3faff",
          "border": "1px solid #e0f1ff",
          "box-sizing": "border-box",
          "width": "20px",
          "height" : "40px"
        },
        "input:focus": {
          "-webkit-box-shadow": "inset 0px 0px 3px 0px #b0dcff !important",
          "box-shadow": "inset 0px 0px 3px 0px #b0dcff !important",
          "border-color": "#b0dcff !important",
          "width": "20px",
          "height" : "40px"
        },
        "button": {
          "pointer-events": "none",
          "opacity": ".5",


          'box-sizing': 'border-box',
          'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
          'font-size': '15px',
          'line-height': '1',
          // 'width': 'auto !important',
          'outline': '0',
          'padding': '.5278em',
          'vertical-align': 'baseline',
          'height': '50px',
          'background-color': '#a4182d',
          'font-family': 'sans-serif',
          'text-transform': 'uppercase',
          'border': '0 solid transparent',
          'color': '#fff',
          // 'cursor': 'pointer',
          'flex': '0.61 1 auto !important'
        },
        "button:active": {
          "filter": "brightness(112%)",
          "text-align": "center"
        },
        ".card-number.card-type-visa": {
          "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-visa@2x.png) no-repeat right",
          "background-position-y": "0px",
          "background-size": "70px 75px",
          "width": "50px"
        },
        ".card-number.card-type-mastercard": {
          "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-mastercard@2x.png) no-repeat right",
          "background-position-y": "4px",
          "background-size": "60px 64px"
        },
        ".card-number.card-type-discover": {
          "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-discover@2x.png) no-repeat right",
          "background-position-y": "-5px",
          "background-size": "90px 96px"
        },
        ".card-number.card-type-jcb": {
          "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-jcb@2x.png) no-repeat right",
          "background-position-y": "0px",
          "background-size": "48px 82px"
        },
        ".card-number.card-type-amex": {
          "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-amex@2x.png) no-repeat right",
          "background-position-y": "-4px",
          "background-size": "55px 98px"
        }
      }
  };
  }
  
}



// WEBPACK FOOTER //
// ./src/app/order/payment/tsys-payment.js